<script setup>
import { computed, toRefs } from "vue";

const props = defineProps({
  modelValue: Array,
  label: { type: String, default: "Select" },
  blurCheck: { type: Function },
  errorMessages: { type: Function },
  isRequired: { type: Boolean, default: false },
  withNA: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get: () => props.modelValue,
  set: (newValue) => emit("update:modelValue", newValue),
});

const { label, blurCheck, errorMessages, isRequired } = toRefs(props);
</script>
<template>
  <v-radio-group
    v-model="value"
    class="custom-radio-group"
    color="primary"
    hide-details="auto"
    inline
    :error-messages="errorMessages"
    @blur="blurCheck"
  >
    <v-radio :value="true" label="Yes" />
    <v-radio :value="false" label="No" />
    <v-radio :value="null" label="N/A" v-if="withNA == true" />
    <template #label>
      {{ label }}
      <span v-if="isRequired" class="ml-1 red--text">
        <strong> *</strong>
      </span>
    </template>
  </v-radio-group>
</template>
